import { render, staticRenderFns } from "./RomaAdvance.vue?vue&type=template&id=61dd8e25"
import script from "./RomaAdvance.vue?vue&type=script&lang=ts"
export * from "./RomaAdvance.vue?vue&type=script&lang=ts"
import style0 from "./RomaAdvance.vue?vue&type=style&index=0&id=61dd8e25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports